var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitorbased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05566 8.11013C7.05566 8.93525 7.38344 9.72657 7.96689 10.31C8.55033 10.8935 9.34166 11.2212 10.1668 11.2212C10.9919 11.2212 11.7832 10.8935 12.3667 10.31C12.9501 9.72657 13.2779 8.93525 13.2779 8.11013C13.2779 7.28502 12.9501 6.49369 12.3667 5.91025C11.7832 5.3268 10.9919 4.99902 10.1668 4.99902C9.34166 4.99902 8.55033 5.3268 7.96689 5.91025C7.38344 6.49369 7.05566 7.28502 7.05566 8.11013Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18.9987V17.4431C5.5 16.618 5.82778 15.8267 6.41122 15.2433C6.99467 14.6598 7.78599 14.332 8.61111 14.332H11.7222C12.5473 14.332 13.3387 14.6598 13.9221 15.2433C14.5056 15.8267 14.8333 16.618 14.8333 17.4431V18.9987",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6113 5.10059C16.2805 5.27193 16.8737 5.66113 17.2973 6.20683C17.7208 6.75252 17.9508 7.42367 17.9508 8.11447C17.9508 8.80527 17.7208 9.47642 17.2973 10.0221C16.8737 10.5678 16.2805 10.957 15.6113 11.1284",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 19.0002V17.4446C19.4961 16.758 19.2651 16.0919 18.8431 15.5503C18.421 15.0086 17.8316 14.6219 17.1667 14.4502",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorbased);
export default __webpack_public_path__ + "static/media/visitorbased.04cce9135cdf657a1f5d9a66154697a3.svg";
export { ForwardRef as ReactComponent };